"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoSubDocument = void 0;
class MongoSubDocument {
}
exports.MongoSubDocument = MongoSubDocument;
//# sourceMappingURL=mongo-sub-document.model.js.map